import { defineComponent as pa, inject as $e, toRef as oe, ref as _, watch as ha, computed as y, openBlock as c, createElementBlock as k, normalizeClass as r, unref as e, createElementVNode as m, renderSlot as V, Fragment as ka, renderList as ga, toDisplayString as A, createCommentVNode as h, createVNode as v, withDirectives as O, withCtx as w, vShow as Z, withKeys as j, createBlock as M, createTextVNode as Me, nextTick as ya } from "vue";
import J from "./index592.js";
import { ElButton as Ie } from "./index536.js";
import { ElInput as ee } from "./index545.js";
import { ElIcon as D } from "./index538.js";
import { ArrowRight as ue, DArrowLeft as Ye, ArrowLeft as Ee, DArrowRight as Fe } from "./index537.js";
import { panelDateRangeProps as wa } from "./index866.js";
import { useRangePicker as Ca } from "./index867.js";
import { isValidRange as Ne, correctlyParseUserInput as Pa, getDefaultValue as Va } from "./index862.js";
import { usePanelDateRange as Da } from "./index868.js";
import { ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY as Ta } from "./index632.js";
import Ae from "./index865.js";
import Se from "./index864.js";
import xe from "./index863.js";
import Be from "./index591.js";
import Le from "./index598.js";
import { PICKER_BASE_INJECTION_KEY as Ra, DEFAULT_FORMATS_TIME as $a, DEFAULT_FORMATS_DATE as Ma } from "./index579.js";
import { useLocale as Ia } from "./index597.js";
import { extractTimeFormat as Ya, extractDateFormat as Ea } from "./index578.js";
import { useFormDisabled as Fa } from "./index586.js";
const Na = ["disabled", "onClick"], Aa = ["aria-label", "disabled"], Sa = ["aria-label", "disabled"], xa = ["disabled", "aria-label"], Ba = ["disabled", "aria-label"], La = ["tabindex", "aria-disabled"], _a = ["tabindex", "aria-disabled"], Oa = ["disabled", "aria-label"], Ka = ["disabled", "aria-label"], Ua = ["aria-label", "disabled"], za = ["disabled", "aria-label"], Ja = ["tabindex", "aria-disabled"], Wa = ["tabindex", "aria-disabled"], ae = "month";
var fl = /* @__PURE__ */ pa({
  __name: "panel-date-range",
  props: wa,
  emits: [
    "pick",
    "set-picker-option",
    "calendar-change",
    "panel-change",
    "clear"
  ],
  setup(_e, { emit: Oe }) {
    const b = _e, I = Oe, Y = $e(Ra), Ke = $e(
      Ta,
      void 0
    ), { disabledDate: g, cellClassName: de, defaultTime: W, clearable: ve } = Y.props, le = oe(Y.props, "format"), me = oe(Y.props, "shortcuts"), fe = oe(Y.props, "defaultValue"), { lang: E } = Ia(), s = _(J().locale(E.value)), o = _(J().locale(E.value).add(1, ae)), {
      minDate: n,
      maxDate: i,
      rangeState: T,
      ppNs: u,
      drpNs: f,
      handleChangeRange: ce,
      handleRangeConfirm: F,
      handleShortcutClick: Ue,
      onSelect: te,
      parseValue: be,
      t: p
    } = Ca(b, {
      defaultValue: fe,
      defaultTime: W,
      leftDate: s,
      rightDate: o,
      unit: ae,
      sortDates: Re
    });
    ha(
      () => b.visible,
      (a) => {
        !a && T.value.selecting && (be(b.parsedValue), te(!1));
      }
    );
    const S = _({
      min: null,
      max: null
    }), R = _({
      min: null,
      max: null
    }), {
      leftCurrentView: P,
      rightCurrentView: C,
      leftCurrentViewRef: ne,
      rightCurrentViewRef: ie,
      leftYear: pe,
      rightYear: he,
      leftMonth: re,
      rightMonth: ke,
      leftYearLabel: ze,
      rightYearLabel: Je,
      showLeftPicker: q,
      showRightPicker: G,
      handleLeftYearPick: We,
      handleRightYearPick: qe,
      handleLeftMonthPick: Ge,
      handleRightMonthPick: He,
      handlePanelChange: $,
      adjustDateByView: K
    } = Da(b, I, s, o), ge = y(() => !!me.value.length), Qe = y(() => S.value.min !== null ? S.value.min : n.value ? n.value.format(se.value) : ""), Xe = y(() => S.value.max !== null ? S.value.max : i.value || n.value ? (i.value || n.value).format(se.value) : ""), Ze = y(() => R.value.min !== null ? R.value.min : n.value ? n.value.format(U.value) : ""), je = y(() => R.value.max !== null ? R.value.max : i.value || n.value ? (i.value || n.value).format(U.value) : ""), U = y(() => b.timeFormat || Ya(le.value || "") || $a), se = y(() => b.dateFormat || Ea(le.value || "") || Ma), ea = (a) => Ne(a) && (g ? !g(a[0].toDate()) && !g(a[1].toDate()) : !0), aa = () => {
      s.value = K(
        P.value,
        s.value,
        !1
      ), b.unlinkPanels || (o.value = s.value.add(1, "month")), $("year");
    }, la = () => {
      s.value = s.value.subtract(1, "month"), b.unlinkPanels || (o.value = s.value.add(1, "month")), $("month");
    }, ta = () => {
      b.unlinkPanels ? o.value = K(
        C.value,
        o.value,
        !0
      ) : (s.value = K(
        C.value,
        s.value,
        !0
      ), o.value = s.value.add(1, "month")), $("year");
    }, na = () => {
      b.unlinkPanels ? o.value = o.value.add(1, "month") : (s.value = s.value.add(1, "month"), o.value = s.value.add(1, "month")), $("month");
    }, ia = () => {
      s.value = K(P.value, s.value, !0), $("year");
    }, ra = () => {
      s.value = s.value.add(1, "month"), $("month");
    }, sa = () => {
      o.value = K(
        C.value,
        o.value,
        !1
      ), $("year");
    }, oa = () => {
      o.value = o.value.subtract(1, "month"), $("month");
    }, H = y(() => {
      const a = (re.value + 1) % 12, l = re.value + 1 >= 12 ? 1 : 0;
      return b.unlinkPanels && new Date(pe.value + l, a) < new Date(he.value, ke.value);
    }), Q = y(() => b.unlinkPanels && he.value * 12 + ke.value - (pe.value * 12 + re.value + 1) >= 12), d = Fa(), ua = y(() => !(n.value && i.value && !T.value.selecting && Ne([n.value, i.value]) && !d.value)), X = y(
      () => b.type === "datetime" || b.type === "datetimerange"
    ), ye = (a, l) => {
      if (a)
        return W ? J(
          W[l] || W
        ).locale(E.value).year(a.year()).month(a.month()).date(a.date()) : a;
    }, we = (a, l = !0) => {
      const t = a.minDate, N = a.maxDate, L = ye(t, 0), z = ye(N, 1);
      i.value === z && n.value === L || (I("calendar-change", [t.toDate(), N && N.toDate()]), i.value = z, n.value = L, !X.value && l && (l = !L || !z), F(l));
    }, x = _(!1), B = _(!1), da = () => {
      x.value = !1;
    }, va = () => {
      B.value = !1;
    }, Ce = (a, l) => {
      S.value[l] = a;
      const t = J(a, se.value).locale(E.value);
      if (t.isValid()) {
        if (g && g(t.toDate()))
          return;
        l === "min" ? (s.value = t, n.value = (n.value || s.value).year(t.year()).month(t.month()).date(t.date()), !b.unlinkPanels && (!i.value || i.value.isBefore(n.value)) && (o.value = t.add(1, "month"), i.value = n.value.add(1, "month"))) : (o.value = t, i.value = (i.value || o.value).year(t.year()).month(t.month()).date(t.date()), !b.unlinkPanels && (!n.value || n.value.isAfter(i.value)) && (s.value = t.subtract(1, "month"), n.value = i.value.subtract(1, "month"))), Re(n.value, i.value), F(!0);
      }
    }, Pe = (a, l) => {
      S.value[l] = null;
    }, Ve = (a, l) => {
      R.value[l] = a;
      const t = J(a, U.value).locale(E.value);
      t.isValid() && (l === "min" ? (x.value = !0, n.value = (n.value || s.value).hour(t.hour()).minute(t.minute()).second(t.second()), s.value = n.value) : (B.value = !0, i.value = (i.value || o.value).hour(t.hour()).minute(t.minute()).second(t.second()), o.value = i.value));
    }, De = (a, l) => {
      R.value[l] = null, l === "min" ? (s.value = n.value, x.value = !1, (!i.value || i.value.isBefore(n.value)) && (i.value = n.value)) : (o.value = i.value, B.value = !1, i.value && i.value.isBefore(n.value) && (n.value = i.value)), F(!0);
    }, ma = (a, l, t) => {
      R.value.min || (a && (n.value = (n.value || s.value).hour(a.hour()).minute(a.minute()).second(a.second())), t || (x.value = l), (!i.value || i.value.isBefore(n.value)) && (i.value = n.value, o.value = a, ya(() => {
        be(b.parsedValue);
      })), F(!0));
    }, fa = (a, l, t) => {
      R.value.max || (a && (i.value = (i.value || o.value).hour(a.hour()).minute(a.minute()).second(a.second())), t || (B.value = l), i.value && i.value.isBefore(n.value) && (n.value = i.value), F(!0));
    }, ca = () => {
      Te(), I("clear");
    }, Te = () => {
      let a = null;
      Y?.emptyValues && (a = Y.emptyValues.valueOnClear.value), s.value = Va(e(fe), {
        lang: e(E),
        unit: "month",
        unlinkPanels: b.unlinkPanels
      })[0], o.value = s.value.add(1, "month"), i.value = void 0, n.value = void 0, F(!0), I("pick", a);
    }, ba = (a) => Pa(
      a,
      le.value || "",
      E.value,
      Ke
    );
    function Re(a, l) {
      if (b.unlinkPanels && l) {
        const t = a?.year() || 0, N = a?.month() || 0, L = l.year(), z = l.month();
        o.value = t === L && N === z ? l.add(1, ae) : l;
      } else
        o.value = s.value.add(1, ae), l && (o.value = o.value.hour(l.hour()).minute(l.minute()).second(l.second()));
    }
    return I("set-picker-option", ["isValidValue", ea]), I("set-picker-option", ["parseUserInput", ba]), I("set-picker-option", ["handleClear", Te]), (a, l) => (c(), k(
      "div",
      {
        class: r([
          e(u).b(),
          e(f).b(),
          e(u).is("border", a.border),
          e(u).is("disabled", e(d)),
          {
            "has-sidebar": a.$slots.sidebar || ge.value,
            "has-time": X.value
          }
        ])
      },
      [
        m(
          "div",
          {
            class: r(e(u).e("body-wrapper"))
          },
          [
            V(a.$slots, "sidebar", {
              class: r(e(u).e("sidebar"))
            }),
            ge.value ? (c(), k(
              "div",
              {
                key: 0,
                class: r(e(u).e("sidebar"))
              },
              [
                (c(!0), k(
                  ka,
                  null,
                  ga(me.value, (t, N) => (c(), k("button", {
                    key: N,
                    type: "button",
                    disabled: e(d),
                    class: r(e(u).e("shortcut")),
                    onClick: (L) => e(Ue)(t)
                  }, A(t.text), 11, Na))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            )) : h("v-if", !0),
            m(
              "div",
              {
                class: r(e(u).e("body"))
              },
              [
                X.value ? (c(), k(
                  "div",
                  {
                    key: 0,
                    class: r(e(f).e("time-header"))
                  },
                  [
                    m(
                      "span",
                      {
                        class: r(e(f).e("editors-wrap"))
                      },
                      [
                        m(
                          "span",
                          {
                            class: r(e(f).e("time-picker-wrap"))
                          },
                          [
                            v(e(ee), {
                              size: "small",
                              disabled: e(T).selecting || e(d),
                              placeholder: e(p)("el.datepicker.startDate"),
                              class: r(e(f).e("editor")),
                              "model-value": Qe.value,
                              "validate-event": !1,
                              readonly: !a.editable,
                              onInput: l[0] || (l[0] = (t) => Ce(t, "min")),
                              onChange: l[1] || (l[1] = (t) => Pe(t, "min"))
                            }, null, 8, ["disabled", "placeholder", "class", "model-value", "readonly"])
                          ],
                          2
                          /* CLASS */
                        ),
                        O((c(), k(
                          "span",
                          {
                            class: r(e(f).e("time-picker-wrap"))
                          },
                          [
                            v(e(ee), {
                              size: "small",
                              class: r(e(f).e("editor")),
                              disabled: e(T).selecting || e(d),
                              placeholder: e(p)("el.datepicker.startTime"),
                              "model-value": Ze.value,
                              "validate-event": !1,
                              readonly: !a.editable,
                              onFocus: l[2] || (l[2] = (t) => x.value = !0),
                              onInput: l[3] || (l[3] = (t) => Ve(t, "min")),
                              onChange: l[4] || (l[4] = (t) => De(t, "min"))
                            }, null, 8, ["class", "disabled", "placeholder", "model-value", "readonly"]),
                            v(e(Be), {
                              visible: x.value,
                              format: U.value,
                              "datetime-role": "start",
                              "parsed-value": e(n) || s.value,
                              onPick: ma
                            }, null, 8, ["visible", "format", "parsed-value"])
                          ],
                          2
                          /* CLASS */
                        )), [
                          [e(Le), da]
                        ])
                      ],
                      2
                      /* CLASS */
                    ),
                    m("span", null, [
                      v(e(D), null, {
                        default: w(() => [
                          v(e(ue))
                        ]),
                        _: 1
                        /* STABLE */
                      })
                    ]),
                    m(
                      "span",
                      {
                        class: r([e(f).e("editors-wrap"), "is-right"])
                      },
                      [
                        m(
                          "span",
                          {
                            class: r(e(f).e("time-picker-wrap"))
                          },
                          [
                            v(e(ee), {
                              size: "small",
                              class: r(e(f).e("editor")),
                              disabled: e(T).selecting || e(d),
                              placeholder: e(p)("el.datepicker.endDate"),
                              "model-value": Xe.value,
                              readonly: !e(n) || !a.editable,
                              "validate-event": !1,
                              onInput: l[5] || (l[5] = (t) => Ce(t, "max")),
                              onChange: l[6] || (l[6] = (t) => Pe(t, "max"))
                            }, null, 8, ["class", "disabled", "placeholder", "model-value", "readonly"])
                          ],
                          2
                          /* CLASS */
                        ),
                        O((c(), k(
                          "span",
                          {
                            class: r(e(f).e("time-picker-wrap"))
                          },
                          [
                            v(e(ee), {
                              size: "small",
                              class: r(e(f).e("editor")),
                              disabled: e(T).selecting || e(d),
                              placeholder: e(p)("el.datepicker.endTime"),
                              "model-value": je.value,
                              readonly: !e(n) || !a.editable,
                              "validate-event": !1,
                              onFocus: l[7] || (l[7] = (t) => e(n) && (B.value = !0)),
                              onInput: l[8] || (l[8] = (t) => Ve(t, "max")),
                              onChange: l[9] || (l[9] = (t) => De(t, "max"))
                            }, null, 8, ["class", "disabled", "placeholder", "model-value", "readonly"]),
                            v(e(Be), {
                              "datetime-role": "end",
                              visible: B.value,
                              format: U.value,
                              "parsed-value": e(i) || o.value,
                              onPick: fa
                            }, null, 8, ["visible", "format", "parsed-value"])
                          ],
                          2
                          /* CLASS */
                        )), [
                          [e(Le), va]
                        ])
                      ],
                      2
                      /* CLASS */
                    )
                  ],
                  2
                  /* CLASS */
                )) : h("v-if", !0),
                m(
                  "div",
                  {
                    class: r([[e(u).e("content"), e(f).e("content")], "is-left"])
                  },
                  [
                    m(
                      "div",
                      {
                        class: r(e(f).e("header"))
                      },
                      [
                        m("button", {
                          type: "button",
                          class: r([e(u).e("icon-btn"), "d-arrow-left"]),
                          "aria-label": e(p)("el.datepicker.prevYear"),
                          disabled: e(d),
                          onClick: aa
                        }, [
                          V(a.$slots, "prev-year", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Ye))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Aa),
                        O(m("button", {
                          type: "button",
                          class: r([e(u).e("icon-btn"), "arrow-left"]),
                          "aria-label": e(p)("el.datepicker.prevMonth"),
                          disabled: e(d),
                          onClick: la
                        }, [
                          V(a.$slots, "prev-month", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Ee))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Sa), [
                          [Z, e(P) === "date"]
                        ]),
                        a.unlinkPanels ? (c(), k("button", {
                          key: 0,
                          type: "button",
                          disabled: !Q.value || e(d),
                          class: r([[
                            e(u).e("icon-btn"),
                            e(u).is("disabled", !Q.value || e(d))
                          ], "d-arrow-right"]),
                          "aria-label": e(p)("el.datepicker.nextYear"),
                          onClick: ia
                        }, [
                          V(a.$slots, "next-year", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Fe))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, xa)) : h("v-if", !0),
                        a.unlinkPanels && e(P) === "date" ? (c(), k("button", {
                          key: 1,
                          type: "button",
                          disabled: !H.value || e(d),
                          class: r([[
                            e(u).e("icon-btn"),
                            e(u).is("disabled", !H.value || e(d))
                          ], "arrow-right"]),
                          "aria-label": e(p)("el.datepicker.nextMonth"),
                          onClick: ra
                        }, [
                          V(a.$slots, "next-month", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(ue))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ba)) : h("v-if", !0),
                        m("div", null, [
                          m("span", {
                            role: "button",
                            class: r(e(f).e("header-label")),
                            "aria-live": "polite",
                            tabindex: a.disabled ? void 0 : 0,
                            "aria-disabled": a.disabled,
                            onKeydown: l[10] || (l[10] = j((t) => e(q)("year"), ["enter"])),
                            onClick: l[11] || (l[11] = (t) => e(q)("year"))
                          }, A(e(ze)), 43, La),
                          O(m("span", {
                            role: "button",
                            "aria-live": "polite",
                            tabindex: a.disabled ? void 0 : 0,
                            "aria-disabled": a.disabled,
                            class: r([
                              e(f).e("header-label"),
                              { active: e(P) === "month" }
                            ]),
                            onKeydown: l[12] || (l[12] = j((t) => e(q)("month"), ["enter"])),
                            onClick: l[13] || (l[13] = (t) => e(q)("month"))
                          }, A(e(p)(`el.datepicker.month${s.value.month() + 1}`)), 43, _a), [
                            [Z, e(P) === "date"]
                          ])
                        ])
                      ],
                      2
                      /* CLASS */
                    ),
                    e(P) === "date" ? (c(), M(xe, {
                      key: 0,
                      ref_key: "leftCurrentViewRef",
                      ref: ne,
                      "selection-mode": "range",
                      date: s.value,
                      "min-date": e(n),
                      "max-date": e(i),
                      "range-state": e(T),
                      "disabled-date": e(g),
                      "cell-class-name": e(de),
                      "show-week-number": a.showWeekNumber,
                      disabled: e(d),
                      onChangerange: e(ce),
                      onPick: we,
                      onSelect: e(te)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "show-week-number", "disabled", "onChangerange", "onSelect"])) : h("v-if", !0),
                    e(P) === "year" ? (c(), M(Ae, {
                      key: 1,
                      ref_key: "leftCurrentViewRef",
                      ref: ne,
                      "selection-mode": "year",
                      date: s.value,
                      "disabled-date": e(g),
                      "parsed-value": a.parsedValue,
                      disabled: e(d),
                      onPick: e(We)
                    }, null, 8, ["date", "disabled-date", "parsed-value", "disabled", "onPick"])) : h("v-if", !0),
                    e(P) === "month" ? (c(), M(Se, {
                      key: 2,
                      ref_key: "leftCurrentViewRef",
                      ref: ne,
                      "selection-mode": "month",
                      date: s.value,
                      "parsed-value": a.parsedValue,
                      "disabled-date": e(g),
                      disabled: e(d),
                      onPick: e(Ge)
                    }, null, 8, ["date", "parsed-value", "disabled-date", "disabled", "onPick"])) : h("v-if", !0)
                  ],
                  2
                  /* CLASS */
                ),
                m(
                  "div",
                  {
                    class: r([[e(u).e("content"), e(f).e("content")], "is-right"])
                  },
                  [
                    m(
                      "div",
                      {
                        class: r(e(f).e("header"))
                      },
                      [
                        a.unlinkPanels ? (c(), k("button", {
                          key: 0,
                          type: "button",
                          disabled: !Q.value || e(d),
                          class: r([[
                            e(u).e("icon-btn"),
                            e(u).is("disabled", !Q.value || e(d))
                          ], "d-arrow-left"]),
                          "aria-label": e(p)("el.datepicker.prevYear"),
                          onClick: sa
                        }, [
                          V(a.$slots, "prev-year", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Ye))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Oa)) : h("v-if", !0),
                        a.unlinkPanels && e(C) === "date" ? (c(), k("button", {
                          key: 1,
                          type: "button",
                          disabled: !H.value || e(d),
                          class: r([[
                            e(u).e("icon-btn"),
                            e(u).is("disabled", !H.value || e(d))
                          ], "arrow-left"]),
                          "aria-label": e(p)("el.datepicker.prevMonth"),
                          onClick: oa
                        }, [
                          V(a.$slots, "prev-month", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Ee))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ka)) : h("v-if", !0),
                        m("button", {
                          type: "button",
                          "aria-label": e(p)("el.datepicker.nextYear"),
                          class: r([e(u).e("icon-btn"), "d-arrow-right"]),
                          disabled: e(d),
                          onClick: ta
                        }, [
                          V(a.$slots, "next-year", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(Fe))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ua),
                        O(m("button", {
                          type: "button",
                          class: r([e(u).e("icon-btn"), "arrow-right"]),
                          disabled: e(d),
                          "aria-label": e(p)("el.datepicker.nextMonth"),
                          onClick: na
                        }, [
                          V(a.$slots, "next-month", {}, () => [
                            v(e(D), null, {
                              default: w(() => [
                                v(e(ue))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, za), [
                          [Z, e(C) === "date"]
                        ]),
                        m("div", null, [
                          m("span", {
                            role: "button",
                            class: r(e(f).e("header-label")),
                            "aria-live": "polite",
                            tabindex: a.disabled ? void 0 : 0,
                            "aria-disabled": a.disabled,
                            onKeydown: l[14] || (l[14] = j((t) => e(G)("year"), ["enter"])),
                            onClick: l[15] || (l[15] = (t) => e(G)("year"))
                          }, A(e(Je)), 43, Ja),
                          O(m("span", {
                            role: "button",
                            "aria-live": "polite",
                            tabindex: a.disabled ? void 0 : 0,
                            "aria-disabled": a.disabled,
                            class: r([
                              e(f).e("header-label"),
                              { active: e(C) === "month" }
                            ]),
                            onKeydown: l[16] || (l[16] = j((t) => e(G)("month"), ["enter"])),
                            onClick: l[17] || (l[17] = (t) => e(G)("month"))
                          }, A(e(p)(`el.datepicker.month${o.value.month() + 1}`)), 43, Wa), [
                            [Z, e(C) === "date"]
                          ])
                        ])
                      ],
                      2
                      /* CLASS */
                    ),
                    e(C) === "date" ? (c(), M(xe, {
                      key: 0,
                      ref_key: "rightCurrentViewRef",
                      ref: ie,
                      "selection-mode": "range",
                      date: o.value,
                      "min-date": e(n),
                      "max-date": e(i),
                      "range-state": e(T),
                      "disabled-date": e(g),
                      "cell-class-name": e(de),
                      "show-week-number": a.showWeekNumber,
                      disabled: e(d),
                      onChangerange: e(ce),
                      onPick: we,
                      onSelect: e(te)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "show-week-number", "disabled", "onChangerange", "onSelect"])) : h("v-if", !0),
                    e(C) === "year" ? (c(), M(Ae, {
                      key: 1,
                      ref_key: "rightCurrentViewRef",
                      ref: ie,
                      "selection-mode": "year",
                      date: o.value,
                      "disabled-date": e(g),
                      "parsed-value": a.parsedValue,
                      disabled: e(d),
                      onPick: e(qe)
                    }, null, 8, ["date", "disabled-date", "parsed-value", "disabled", "onPick"])) : h("v-if", !0),
                    e(C) === "month" ? (c(), M(Se, {
                      key: 2,
                      ref_key: "rightCurrentViewRef",
                      ref: ie,
                      "selection-mode": "month",
                      date: o.value,
                      "parsed-value": a.parsedValue,
                      "disabled-date": e(g),
                      disabled: e(d),
                      onPick: e(He)
                    }, null, 8, ["date", "parsed-value", "disabled-date", "disabled", "onPick"])) : h("v-if", !0)
                  ],
                  2
                  /* CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        ),
        a.showFooter && X.value && (a.showConfirm || e(ve)) ? (c(), k(
          "div",
          {
            key: 0,
            class: r(e(u).e("footer"))
          },
          [
            e(ve) ? (c(), M(e(Ie), {
              key: 0,
              text: "",
              size: "small",
              class: r(e(u).e("link-btn")),
              onClick: ca
            }, {
              default: w(() => [
                Me(
                  A(e(p)("el.datepicker.clear")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])) : h("v-if", !0),
            a.showConfirm ? (c(), M(e(Ie), {
              key: 1,
              plain: "",
              size: "small",
              class: r(e(u).e("link-btn")),
              disabled: ua.value,
              onClick: l[18] || (l[18] = (t) => e(F)(!1))
            }, {
              default: w(() => [
                Me(
                  A(e(p)("el.datepicker.confirm")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class", "disabled"])) : h("v-if", !0)
          ],
          2
          /* CLASS */
        )) : h("v-if", !0)
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  fl as default
};
